import { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { MAIN_LAMBDA } from "../utils/constants";
import { POST } from "../utils/api";
import { Alert } from "@mui/material";

// Theme colors
const primaryColor = "#003663";
const accentColor = "#FBD215";

// Input styling shared across fields
const inputStyle = {
  width: "100%",
  padding: "12px 16px",
  borderRadius: "12px",
  border: "1px solid #E5E9F2",
  backgroundColor: "#F8FAFC",
  marginBottom: "16px",
  fontSize: "16px",
  fontWeight: 500,
  color: primaryColor,
  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
};

const cardStyle = {
  backgroundColor: "#ffffff",
  borderRadius: "16px",
  padding: "32px 24px",
  boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
  maxWidth: "600px",
  width: "100%",
};

const ContactForm = () => {
  const translation = useTranslation();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const [messageSubmitted, setMessageSubmitted] = useState("");
  const onSubmit = (data) => {
      POST(`${MAIN_LAMBDA}/contact-us`, {
        body: JSON.stringify(data),
      } ).then((response) => {
        setMessageSubmitted(true);
      })
      setMessageSubmitted(true);
    
  };


  return (
    /* "handleSubmit" will validate your inputs before invoking "onSubmit" */
    <form
      onSubmit={handleSubmit(onSubmit)}
      style={{
        ...cardStyle,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* register your input into the hook by invoking the "register" function */}
      <h3 style={{ color: primaryColor, fontWeight: 700, marginBottom: 24 }}>
        {translation.t("contact_us")}
      </h3>

      <input
        style={inputStyle}
        type="text"
        placeholder={translation.t("first_name")}
        {...register("first_name", { required: true, maxLength: 80 })}
      />

      <input
        style={inputStyle}
        type="text"
        placeholder={translation.t("last_name")}
        {...register("last_name", { required: true, maxLength: 100 })}
      />
      <input
        style={inputStyle}
        type="text"
        placeholder={translation.t("Email")}
        {...register("email", { required: true, pattern: /^\S+@\S+$/i })}
      />
      <input
        style={inputStyle}
        type="tel"
        placeholder={translation.t("phone")}
        {...register("phone", {
          required: false,
          minLength: 6,
          maxLength: 12,
        })}
      />

      <textarea
        style={{ ...inputStyle, height: 120, resize: "vertical" }}
        placeholder={translation.t("message")}
        {...register("message", { required: true })}
      />
      {/* errors will return when field validation fails  */}
      {/* {errors.exampleRequired && <span>This field is required</span>} */}

      {messageSubmitted === true && (
        <Alert severity="success">
          {translation.t("message_submitted")}
          <br />
        </Alert>
      )}

      {messageSubmitted === false && (
        <Alert severity="error">
        {translation.t("message_not_submitted")}
          <br />
        </Alert>
      )}

      <input
        value={translation.t("submit")}
        type="submit"
        style={{
          backgroundColor: accentColor,
          color: primaryColor,
          border: "none",
          borderRadius: "30px",
          padding: "14px 48px",
          fontWeight: 800,
          fontSize: "1rem",
          cursor: "pointer",
          marginTop: 8,
          transition: "all 0.2s ease-in-out",
        }}
        onMouseEnter={e => { e.currentTarget.style.transform = "scale(1.05)";}}
        onMouseLeave={e => { e.currentTarget.style.transform = "scale(1)";}}
      />
    </form>
  );
};

export default ContactForm;
